import { api } from "./apiCore";

export const notificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteNotifications: builder.mutation<unknown, { app_id: number | string }>(
      {
        query: (value) => ({
          url: `/auth/applications/${value.app_id}/events/clear`,
          method: "POST",
        }),
      }
    ),
  }),
});

export const { useDeleteNotificationsMutation } = notificationsApi;
